import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getContractConfig } from "../../services/backend/ContractConfigService";
import {
  cutoffBlockReason,
  cutoffNotice,
  cutoffWindow,
  resolvePaymentCutoff,
} from "../../paymentCutoff";

// Fecha de corte mensual de las actas (payment-monthly-cutoff, D5).
//
// Lee config/contracts.paymentCutoff una vez por montaje de la vista y expone:
//   blockReason(nature)      motivo para deshabilitar enviar / presentar /
//                            aprobar, o null (también null para ADMIN y con el
//                            interruptor apagado)
//   notice(natures, role)    { severity, message } del aviso, o null
//   window(nature)           estado crudo de la ventana
//   loaded                   false mientras la configuración no llega
//
// El reloj es el del cliente y se refresca cada minuto para que el estado
// cambie a medianoche sin recargar. Aquí solo se informa: el backend decide
// con su propio reloj y su propia copia de las reglas, y un 409 suyo llega a
// la vista como mensaje en el snack.
const TICK_MS = 60 * 1000;

export default function usePaymentCutoff() {
  const user = useSelector((state) => state.user.value);
  const [config, setConfig] = useState(null);
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    let active = true;
    (async () => {
      const cfg = await getContractConfig();
      if (active) setConfig(resolvePaymentCutoff(cfg?.paymentCutoff));
    })();
    const id = setInterval(() => setNow(new Date()), TICK_MS);
    return () => {
      active = false;
      clearInterval(id);
    };
  }, []);

  const blockReason = useCallback(
    (nature) => (config ? cutoffBlockReason(config, nature || null, now, user) : null),
    [config, now, user]
  );

  const notice = useCallback(
    (natures, role, options) => (config ? cutoffNotice(config, natures, role, now, options) : null),
    [config, now]
  );

  const window = useCallback(
    (nature) => cutoffWindow(config, nature || null, now),
    [config, now]
  );

  return { config, loaded: !!config, blockReason, notice, window };
}
